import { createFileRoute } from "@tanstack/react-router";
import Camioane from "@/pages/Camioane";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/camioane/")({
  head: () => routeHead("/uk/camioane/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Camioane />
  );
}
